import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { useSelector } from 'react-redux'
import auditBk from "../../../../assets/images/analytics-bg.jpg"

function SkeletonAuditCard({sections, itemsPerSection}){
    const useDarkMode = useSelector(state => state.session.useDarkMode)

    let groups = new Array(sections)
    let items = new Array(itemsPerSection)

    for(let i=0; i < sections; i++){
        groups.push(0)
    }
    for(let i=0; i < itemsPerSection; i++){
        items.push(0)
    }

    return <div>
        <div className="d-flex justify-content-center align-items-end p-5" style={{background: `url(${auditBk})`, backgroundSize: "cover", backgroundPosition: "50% 100%"}}>
            <div className="mr-2 text-center">
                <Skeleton circle height={100} width={100} />
                <h4 className="font-weight-bold mt-2 text-white text-shadow">
                    <Skeleton width={125} height={60} />                    
                </h4>
            </div>
            <div className="text-center">
                <Skeleton circle height={100} width={100} />
                <h4 className="font-weight-bold mt-2 text-white text-shadow">
                    <Skeleton width={125} height={60} />                    
                </h4>
            </div>
        </div>
        <div className="d-flex flex-column text-center justify-content-center mb-4">
            <Skeleton width={300} height={40} className="text-center" />
            <Skeleton width={225} height={35} className="text-center mb-3" />
            <Skeleton width={150} height={30} className="text-center" />
            <Skeleton width={275} height={30} className="text-center" />
            <Skeleton width={350} height={30} className="text-center" />
        </div>
        <Skeleton count={3} width={"60%"} height={50} className="mb-3" />

        {groups.map(group => <>
            <div className="d-flex justify-content-center text-center">
                <duv>
                    <Skeleton circle height={64} width={64} className="mb-2" />
                </duv>
            </div>
            <div className="row">
                <h3 className="mx-auto d-block font-weight-bold">
                    <Skeleton height={30} width={200} className="mb-2" />
                </h3>
            </div>
            <div className="row bg-light-grey capitalize">
                <div className="col-xl-4 col-lg-2 col-md-2 col-sm-2 col-2 text-left" style={{
                    fontWeight: "bold",
                    fontSize: "12pt"
                }}>
                    <div className="d-xl-block d-lg-block d-md-block d-sm-block d-none">
                        METRIC
                    </div>
                </div>
                <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-4 text-right" style={{
                    fontWeight: "bold",
                    fontSize: "12pt"
                }}>
                    <div className="d-xl-block d-lg-block d-md-block d-sm-block d-none">
                        BASELINE<br /> <Skeleton width={150} height={30} /> 
                    </div>
                    <div className="d-xl-none d-lg-none d-md-none d-sm-none d-block h6 font-weight-bold">
                        BASE<br />LINE <Skeleton width={150} height={30} /> 
                    </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3 col-3 text-right" style={{
                    fontWeight: "bold",
                    fontSize: "12pt"
                }}>
                    <div className="d-xl-block d-lg-block d-md-block d-sm-block d-none">
                        <Skeleton height={60} width={100} />
                    </div>
                    <div className="d-xl-none d-lg-none d-md-none d-sm-none d-block h6 font-weight-bold">
                        <Skeleton height={60} width={100} />
                    </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right" style={{
                    fontWeight: "bold",
                    fontSize: "12pt"
                }}>
                    <div className="d-xl-block d-lg-block d-md-none d-sm-none d-none">
                        12 MONTH<br /> AVERAGE &#8224;
                    </div>
                    <div className="d-xl-none d-lg-none d-md-block d-sm-block d-none">
                        MTH<br /> AVG &#8224;
                    </div>
                    <div className="d-xl-none d-lg-none d-md-none d-sm-none d-block h6 font-weight-bold">
                        MTH<br /> AVG &#8224;
                    </div>
                </div>
            </div>
            <div className="mb-4">
                {items.map((metric, key) => <div className={`row pt-2`} style={key % 2 === 1 ? {backgroundColor: useDarkMode ? "#262d33" : "rgb(243 243 243)"} : {}}>
                    <div className="col-xl-4 col-lg-2 col-md-2 col-sm-2 col-2 text-left h4 font-weight-bold">
                        <div className="d-xl-block d-lg-none d-md-none d-sm-none d-none">
                            <Skeleton width={150} height={30} />
                        </div>
                        <div className="d-lg-block d-xl-none d-md-block d-sm-block d-none">
                            <Skeleton width={"100%"} height={30} />
                        </div>
                        <div className="d-lg-none d-xl-none d-md-none d-sm-none d-block h6 font-weight-bold">
                            <Skeleton width={"100%"} height={30} />
                        </div>
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-4 text-right h4 mt-auto font-weight-bold" style={{color: "black"}}>
                        <Skeleton width={50} height={30} className="text-right" />        
                    </div>
                    <div className="col-xl-2 col-lg-3 col-md-3 col-sm-3 col-3 text-right h4 mt-auto font-weight-bold">
                        <Skeleton width={50} height={30} />
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right h4 mt-auto font-weight-bold">
                        <Skeleton width={50} height={30} />
                    </div>
                </div>)}
            </div>
            <br />
        </>)}
    </div>
}

SkeletonAuditCard.defaultProps = {
    sections: 3
}

export default SkeletonAuditCard